import React from 'react'
import "./Blur.css"

function Blur({clr}) {
  return (
      <div className="blur-main">
        <div className="blur" style={{backgroundColor:clr}}>
        
        </div>
      </div>
        
    
  )
}

export default Blur